// extracted by mini-css-extract-plugin
module.exports = {"root":"Fullscreen_root__3a-dw"};